var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComaReverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.18 44.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.23,32.4A14.33,14.33,0,0,0,16.88,43.94c7.79-1.42,12.92-9.17,12.32-16.7C28.5,18.52,22.89,7.63,10.08.17a1.25,1.25,0,0,0-1.7,1.7A46.46,46.46,0,0,1,13,15.59,14.31,14.31,0,0,0,.23,32.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.17,32.4A14.33,14.33,0,0,0,48.82,43.94c7.78-1.42,12.92-9.17,12.32-16.7C60.44,18.52,54.82,7.63,42,.17a1.26,1.26,0,0,0-1.71,1.7,46.41,46.41,0,0,1,4.61,13.72A14.31,14.31,0,0,0,32.17,32.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComaReverse);
export default __webpack_public_path__ + "static/media/coma_reverse.e8ec887f00b4a24c66f5c2a368d6d166.svg";
export { ForwardRef as ReactComponent };